module.exports = __webpack_public_path__ + "img/img-150.f54a80a1.png";